export default __webpack_public_path__ + "static/media/losseiver-logo-stripped-01.70f03fc4.svg";